var _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewsRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5601 11.1716C15.1026 10.8622 14.4809 10.9824 14.1716 11.4399C13.8622 11.8974 13.9824 12.5191 14.4399 12.8284L15.5601 11.1716ZM23 17.4091L23.6359 18.1809C23.8792 17.9804 24.0138 17.6768 23.9989 17.3618C23.984 17.0468 23.8214 16.7573 23.5601 16.5807L23 17.4091ZM14.3641 23.2282C13.9379 23.5794 13.877 24.2096 14.2282 24.6359C14.5794 25.0621 15.2096 25.123 15.6359 24.7718L14.3641 23.2282ZM14.4399 12.8284L22.4399 18.2375L23.5601 16.5807L15.5601 11.1716L14.4399 12.8284ZM22.3641 16.6373L14.3641 23.2282L15.6359 24.7718L23.6359 18.1809L22.3641 16.6373Z",
    fill: "url(#paint0_linear_1470_2865)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1470_2865",
    x1: 15,
    y1: 12,
    x2: 23,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008E7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01CD77"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewsRightArrow);
export default __webpack_public_path__ + "static/media/reviewsRightArrow.d445c00e1c3e1b9c9442fe729b99c921.svg";
export { ForwardRef as ReactComponent };